__turbopack_context__.v({
  "chatInput": "_5d_Bxa_chatInput",
  "input": "_5d_Bxa_input",
});
